module.exports = "/_next/static/images/anniversary-839c468dac03af47de5d104bed251989.jpg";